import React from 'react';
import Button from '../../../Buttons/Button/Button';
import styled from 'styled-components';
import { detectMediaType } from '../../Utils';
import MediaRenderer from '../../MediaRenderer';
import { decodeHTMLTags } from '../../Utils';
import ThemedCheckbox from '../ThemedCheckbox';
import { TString } from '../../../Response/Utils';

interface Props {
	resourceURL: string;
	currency: string;
	title: string;
	description: string;
	price: string;
	externalURL;
	onClick;
	selected?;
	isMultiSelect?;
	isMultiChoice?;
	disabled?;
	miniCards?;
	typeGrid?: boolean;
	onlyImage?: boolean;
	voiceResponse?: boolean;
	langCode: string;
	channel?: string;
	timeStamp?: string;
	handleSubmit?: Function;
	listsCount?: number;
}

const styleVars = getComputedStyle(document.querySelector(':root'));

const Card = styled.button`
  max-width: ${(props: any) => {
		return props.typeGrid ? '440px' : '400px';
	}} !important;

  .card-description {
    color: ${(props: any) => {
			return props.foreground ? props.foreground + 'cc' : '#ffffffcc';
		}};
  }
  s {
      font-weight: normal;
      color: ${(props: any) => {
				return props.foreground ? props.foreground + '99' : '#ffffff99';
			}};
  }
  .card-image:not(.playable-video-card):before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    // border: solid 1px rgba(255, 255, 255, 0.2);
    
    z-index: 1;
    // height: calc(100% - 2px);
    // width: calc(100% - 2px);
    border-radius: ${(props: any) => {
			return props.onlyImage && !props.isMultiSelect ? '12px' : '0px';
		}}
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .mini-card{
    .card-image:before {
      border-radius: 12px !important;
    } 
  }

  &.disabled-card:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: #8080804d;
    width: 100%;
    z-index: 1;
    height: 100%;
    border-radius: ${(props: any) => {
			return props.channel === 'whatsapp' ? '8px' : '12px';
		}};
    cursor: not-allowed;
  }

  &.disabled-card {
    cursor: not-allowed;
    opacity: 0.8;
  }

  &.hoverable:hover:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: ${(props: any) => {
			return props.foreground + '1a';
		}};
    width: 100%;
    z-index: 1;
    height: 100%;
    border-radius: ${(props: any) => {
			return props.channel === 'whatsapp' ? '8px' : '12px';
		}};
  }
  button{
    &:focus-visible {
      background-color: ${(props: any) => {
				return props.foreground + '33';
			}}; 
    }
  }

  &.clickable:focus-visible:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: ${(props: any) => {
			return props.foreground + '33';
		}};
    width: 100%;
    z-index: 1;
    height: 100%;
    border-radius: ${(props: any) => {
			return props.channel === 'whatsapp' ? '8px' : '12px';
		}};
  }

  &.hoverable:active:before,
  &.hoverable.selected:before {
    position: absolute;
    inset: 0;
    content: '';
    left: 0;
    top: 0;
    background-color: ${(props: any) => {
			return props.foreground + '33';
		}};
    width: 100%;
    z-index: 1;
    height: 100%;
    border-radius: ${(props: any) => {
			return props.channel === 'whatsapp' ? '8px' : '12px';
		}};
  }

  & .card-select {
    border-top: 
      ${(props: any) => {
				return !props.onlyImage ? '1px solid' + props.foreground + '4d' : '';
			}};
  }
`;

export default function Cards(props: Props) {
	let {
		resourceURL,
		title,
		description,
		price,
		onlyImage,
		voiceResponse,
		langCode,
		channel,
		listsCount,
		currency,
	} = props;
	title = title ? decodeHTMLTags(title) : '';
	let buttonsDesc = description ? description.split('#CARDBUTTONS#')[1] : '';
	description = description ? description.split('#CARDBUTTONS#')[0] : '';
	description = description ? decodeHTMLTags(description) : '';

	let buttons = buttonsDesc
		? buttonsDesc.match(/<a (?:.*?)(?!\/a)*>(?:.*?)<\/a>/g) //NOSONAR
		: null;
	// description = description
	//   ? description.replace(/<a (?:.*?)(?!\/a)*>(?:.*?)<\/a>/g, '')
	//   : '';

	let buttonsList =
		buttons &&
		buttons.map((e) => {
			return {
				action: e.match(/<a.+?\s*href\s*=\s*["]?([^">]*)["]?/)[1], //NOSONAR
				text: e.match(/>([^>]+)</)[1],
			};
		});
	return (
		<div
			style={
				channel === 'whatsapp'
					? {
							cursor: props.disabled ? 'not-allowed' : '',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							gap: '2px',
					  }
					: { cursor: props.disabled ? 'not-allowed' : '', height: '100%' }
			}
		>
			<Card
				disabled={voiceResponse || props.disabled}
				className={`${
					channel === 'whatsapp'
						? 'whatsapp-card-container '
						: 'card-container '
				}  ${
					(props.isMultiSelect || props.isMultiChoice) && !props.disabled
						? 'hoverable clickable'
						: ''
				} ${props.selected && !props.disabled ? 'selected' : ''} ${
					props.disabled ? 'disabled-card' : ''
				}`}
				{...{
					foreground: styleVars.getPropertyValue('--srvMsgColor'),
					isMultiSelect: props.isMultiSelect,
					onlyImage: props.onlyImage,
					miniCards: props.miniCards,
					channel: channel,
				}}
				onClick={() => props.onClick()}
			>
				{props.miniCards ? (
					<div className='mini-card'>
						<div
							tabIndex={voiceResponse || props.disabled ? -1 : 0}
							className={`card-image ${
								detectMediaType(resourceURL) === 'image'
									? ''
									: 'playable-video-card'
							}`}
						>
							{resourceURL ? (
								<MediaRenderer name={title || description} url={resourceURL} />
							) : null}
						</div>
						{title || description ? (
							<div
								tabIndex={voiceResponse || props.disabled ? -1 : 0}
								className='card-content'
								// style={{ marginBottom: buttons ? '' : '24px' }}
							>
								<div
									className='card-title body-text-1'
									dangerouslySetInnerHTML={{ __html: title }}
								/>
								<div
									className='card-description caption-text'
									dangerouslySetInnerHTML={{ __html: description }}
								/>
							</div>
						) : null}
					</div>
				) : (
					<>
						<div
							tabIndex={voiceResponse || props.disabled ? -1 : 0}
							className={`card-image ${
								onlyImage && !props.isMultiSelect ? 'only-image' : ''
							}${
								detectMediaType(resourceURL) === 'image'
									? ''
									: 'playable-video-card'
							}`}
						>
							{resourceURL ? (
								<MediaRenderer name={title || description} url={resourceURL} />
							) : null}
						</div>
						{(title || description || price) && !onlyImage ? (
							<div
								tabIndex={voiceResponse || props.disabled ? -1 : 0}
								className='card-content'
								// style={{
								// 	marginBottom: buttons || props.isMultiSelect ? '' : '24px',
								// }}
							>
								<div
									className='card-title body-text-1'
									dangerouslySetInnerHTML={{ __html: title }}
								/>

								<div
									className='card-price'
									dangerouslySetInnerHTML={{
										__html: currency == 'USD' ? `$${price}` : `₹${price}`,
									}}
								/>

								<div
									className='card-description caption-text'
									dangerouslySetInnerHTML={{ __html: description }}
								/>
							</div>
						) : null}
					</>
				)}
				{buttons ? (
					<div className='card-buttons'>
						{buttonsList.map((e, i) => {
							return (
								<a
									key={i}
									rel='noreferrer'
									target={
										e.action.indexOf('javascript') === -1 ? '_blank' : null
									}
									href={e.action}
								>
									<Button key={i} label={e.text} size={'small'} fullWidth />
								</a>
							);
						})}
					</div>
				) : null}
				{props.isMultiSelect ? (
					<button className='card-select' disabled={props.disabled}>
						<ThemedCheckbox selected={props.selected} />
						<span className='body-text-2'>
							{props.selected
								? TString({
										labelName: 'SelectedLabel',
										langCode: langCode,
										fromClass: true,
								  })
								: TString({
										labelName: 'SelectLabel',
										langCode: langCode,
										fromClass: true,
								  })}
						</span>
					</button>
				) : null}
			</Card>
			{channel === 'whatsapp' && listsCount > 1 && (
				<div className='card-buttons'>
					<Button
						className='whatsApp-choice-button'
						disabled={props.disabled}
						key={props.title}
						onClick={() => props.handleSubmit(props.title)}
						label='Select'
						size={'small'}
						fullWidth
					/>
				</div>
			)}
		</div>
	);
}

// #CARDBUTTONS#
